<app-sidebar-layout></app-sidebar-layout>
<app-header-layout></app-header-layout>

<div class="pc-container">
    <!-- class="pc-content" --> 
    <div class="h-100" [ngClass]="{'pc-content': currentPath != 'map'}">
        <app-content-layout></app-content-layout>
    </div>
</div>